import React from 'react';
export const VipModuleSection = () => {
  const levels = [{
    title: 'Nivel Inicial',
    color: 'text-familia-green',
    items: ['Para movilidad reducida o mayor necesidad de acompañamiento', 'Propuestas en silla o cama, según las posibilidades', 'Actividades físicas y cognitivas sencillas', 'Instrucciones visuales para comenzar gradualmente']
  }, {
    title: 'Nivel Medio',
    color: 'text-blue-400',
    items: ['Para adultos mayores que participan con apoyo o supervisión', 'Actividades de movilidad, fuerza y equilibrio con acompañamiento', 'Propuestas de atención, lógica y cálculo cotidiano', 'Opciones para adaptar el ritmo de cada rutina']
  }, {
    title: 'Nivel Avanzado',
    color: 'text-purple-400',
    items: ['Para adultos mayores más independientes y activos', 'Propuestas de coordinación, resistencia y movimiento', 'Actividades cognitivas con mayor desafío', 'Alternativas para mantener una participación gradual']
  }];
  return <section id="vip" className="bg-familia-section py-10 md:py-16 px-4 md:px-6" data-id="element-297">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-298">
        <div className="text-center mb-10 md:mb-16" data-id="element-299">
          <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold mb-4 md:mb-6" data-id="element-300">
            ⚡ MÁS EL MÓDULO MAESTRO EXCLUSIVO
          </h2>
          <p className="text-familia-cyan font-bold text-lg md:text-xl mb-4" data-id="element-301">
            MÓDULO MAESTRO — MÁS DE 150 EJERCICIOS POR NIVELES
          </p>
          <p className="text-familia-gray text-[15px] md:text-lg max-w-3xl mx-auto leading-relaxed" data-id="element-302">
            El corazón del Sistema Vitalidad por Niveles: más de 150 actividades
            físicas y cognitivas para aplicar en casa, con instrucciones
            visuales y adaptación gradual. Elige el nivel que mejor se ajuste a
            cada persona y respeta siempre sus posibilidades e indicaciones
            profesionales.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-303">
          {levels.map((level, i) => <div key={i} className="bg-familia-card border border-white/5 p-6 md:p-8 rounded-2xl" data-id="element-304">
              <h3 className={`text-lg md:text-xl font-bold mb-6 ${level.color}`} data-id="element-305">
                {level.title}
              </h3>
              <ul className="space-y-4" data-id="element-306">
                {level.items.map((item, j) => <li key={j} className="flex items-start gap-3 text-sm md:text-base text-white/90" data-id="element-307">
                    <span className={`${level.color} shrink-0`} data-id="element-308">→</span>
                    <span data-id="element-309">{item}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
};